import React, { useEffect, useState } from 'react';
import VirtualizedSelect from 'react-virtualized-select';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SelectWrapper, shapes } from '@cimpress/react-components';
const { Spinner } = shapes;
import { listTemplates } from '../apis/stereotype.api';
import { getI18nInstance } from '../i18n';
import '../styles/index.css';
export const TemplateSelect = (props) => {
    const [templates, setTemplates] = useState(null);
    // when used in conjunction with selectedTemplateOption,
    // allows for client-side populating the select upon creating a template
    // and even selecting back and forth between client-side and server-side data.
    const [pastSelectedTemplates, setPastSelectedTemplates] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [fetchingError, setFetchingError] = useState(null);
    const [lastRefreshKey, setLastRefreshKey] = useState(null);
    const t = getI18nInstance().getFixedT(props.language);
    const addToPastSelectedTemplates = (option) => {
        if (option && !pastSelectedTemplates.some(el => el.value === option.value)) {
            setPastSelectedTemplates(pastSelectedTemplates => pastSelectedTemplates.some(el => el.value === option.value)
                ? pastSelectedTemplates
                : [...pastSelectedTemplates, option]);
        }
    };
    useEffect(() => {
        setPastSelectedTemplates([]);
    }, [props.accessToken]);
    useEffect(() => {
        if (!fetching && (templates === null || lastRefreshKey !== props.refreshKey) && props.accessToken) {
            setFetching(true);
            setLastRefreshKey(props.refreshKey);
            listTemplates(props.accessToken, props.filterTemplateTypeBy, props.filterTemplateMetadataBy)
                .then((templates) => {
                setTemplates(templates);
                setFetching(false);
            })
                .catch((err) => {
                setTemplates(null);
                setFetching(false);
                setFetchingError(err);
                if (props.onError) {
                    props.onError(err);
                }
            });
        }
    }, [props.accessToken, props.refreshKey]);
    const handleChange = (option) => {
        if (props.onChange) {
            props.onChange(option.value);
        }
        if (props.onChangeOption) {
            props.onChangeOption(option);
        }
    };
    const getOptions = () => {
        if (!templates) {
            if (fetchingError) {
                return [{
                        label: t('error'),
                        value: '-1',
                    }];
            }
            if (fetching) {
                return [{
                        label: t('loading'),
                        value: '-1',
                    }];
            }
            return [{
                    label: t('no-data'),
                    value: '-1',
                }];
        }
        return templates
            .map((t) => ({
            label: t.templateName || t.templateId,
            value: t.links.self.href,
        }));
    };
    const options = [...getOptions(), ...pastSelectedTemplates];
    const optionsDeduplicated = options.filter((el, i) => options.findIndex(e => e.value === el.value) === i);
    const selected = props.selectedTemplateOption || options.find(a => a.value === props.selectedTemplateUrl);
    addToPastSelectedTemplates(selected);
    const hasData = !(options.length === 1 && options[0].value === '-1');
    return React.createElement(SelectWrapper, { disabled: !hasData, selectedSelect: VirtualizedSelect, label: hasData
            ? props.label || t('template-select-label')
            : React.createElement("span", { className: 'template-select-label' },
                props.label || t('template-select-label'),
                React.createElement(Spinner, { className: "spinner", size: 'small' })), value: selected, options: optionsDeduplicated, noResultsText: t('no-results-found'), clearable: false, onChange: (option) => handleChange(option), helpText: props.helpText, containerClassName: props.containerClassName, tether: true });
};
//# sourceMappingURL=TemplateSelect.js.map